import { render } from "./OrderItem.vue?vue&type=template&id=3a48cd7a&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=3a48cd7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a48cd7a"

export default script